/**
 * Auth Abstraction Layer — Entry Point
 * Sprint 1, Story 1.2 / Activated Sprint 6
 */

export type { AuthProvider, AuthUser, AuthSession, UserRole, AuthEvent, SignInCredentials } from './types';
export { expressAuthAdapter, getCachedUserResources } from './express-adapter';

import { expressAuthAdapter } from './express-adapter';
import type { AuthProvider } from './types';

export const auth: AuthProvider = expressAuthAdapter;
